import { createContext } from 'react'

export type SplitViewType = 'userGuide' | 'eInvoicePreview' | null

export type SplitViewContextType = {
  activeSplitView: SplitViewType
  setActiveSplitView: (view: SplitViewType) => void
  eInvoicePreviewUrl: string
  setEInvoicePreviewUrl: (url: string) => void
  eInvoicePreviewFileName: string
  setEInvoicePreviewFileName: (fileName: string) => void
  closeAllSplitViews: () => void
}

const initialValue: SplitViewContextType = {
  activeSplitView: null,
  setActiveSplitView: () => null,
  eInvoicePreviewUrl: '',
  setEInvoicePreviewUrl: () => null,
  eInvoicePreviewFileName: '',
  setEInvoicePreviewFileName: () => null,
  closeAllSplitViews: () => null,
}

export const SplitViewContext =
  createContext<SplitViewContextType>(initialValue)
